import { render } from "./index.vue?vue&type=template&id=18d308c2&bindings={\"files\":\"props\",\"current_index\":\"data\",\"slider_items\":\"data\",\"slide\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "18d308c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d308c2')) {
    api.reload('18d308c2', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=18d308c2&bindings={\"files\":\"props\",\"current_index\":\"data\",\"slider_items\":\"data\",\"slide\":\"options\"}", () => {
    api.rerender('18d308c2', render)
  })

}

script.__file = "resources/js/Components/ContentSlider/index.vue"

export default script